var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fltr_ic",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.511,
    height: 21.197,
    viewBox: "0 0 24.511 21.197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M32.978,22.173h-1.95a2.893,2.893,0,0,0-5.691,0H9.533a.533.533,0,1,0,0,1.066h15.8a2.893,2.893,0,0,0,5.691,0h1.95a.533.533,0,0,0,0-1.066Zm-4.8,2.366a1.833,1.833,0,1,1,1.833-1.833A1.833,1.833,0,0,1,28.182,24.539Zm4.8,5.328H24.1a2.893,2.893,0,0,0-5.691,0H9.533a.533.533,0,1,0,0,1.066H18.41a2.893,2.893,0,0,0,5.691,0h8.877a.533.533,0,0,0,0-1.066ZM21.255,32.238a1.833,1.833,0,1,1,1.833-1.833A1.833,1.833,0,0,1,21.255,32.238ZM9.533,15.539h1.95a2.893,2.893,0,0,0,5.691,0h15.8a.533.533,0,0,0,0-1.066h-15.8a2.893,2.893,0,0,0-5.691,0H9.533a.533.533,0,1,0,0,1.066Zm4.8-2.366A1.833,1.833,0,1,1,12.5,15.006,1.833,1.833,0,0,1,14.328,13.173Z",
    transform: "translate(-9 -12.105)",
    fill: "#707070"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.66707d0dda5f499cfdc6e9c7cb40aec7.svg";
export { ForwardRef as ReactComponent };